import React from "react";
import "react-responsive-modal/styles.css";
import moment from "moment";
import Image from "react-bootstrap/Image";
import { Modal } from "react-responsive-modal";
import { PopupIconButtonReusable } from "../../reusableComponents/allPopupReusable/allPopupReusableIconButton/PopupIconButtonReusable";
// import { PopupActionButton } from "../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
// import EnterTableNumber from "../../reusableComponents/allPopupReusable/tableNumberPopup/EnterTableNumber";
import DeletePopup from "../../reusableComponents/allPopupReusable/smallPopup/DeletePopup";
// import isEmpty from "../../../store/validation/is-Empty";
import { NewCountDown } from "../../reusableComponents/allPopupReusable/tableNumberPopup/NewCountDown";

const ViewUserNotificationDetailsPopup = (props) => {
  const currentTime = new Date();
  var endTime = moment(currentTime).format("YYYY-MM-DDTHH:mm");
  const createdAt = new Date(props.sendData.diner_id.createdAt);
  var startTime = moment(createdAt).format("YYYY-MM-DDTHH:mm");

  let dateOne = new Date(startTime);
  let dateTwo = new Date(endTime);

  let msDifference = dateTwo - dateOne;
  let minutes = Math.floor(msDifference / 1000 / 60);

  function time_convert(minutes) {
    var hours = Math.floor(minutes / 60);
    var nMinutes = minutes % 60;
    return hours + " HH : " + nMinutes + " min";
  }

  const updatedTime = new Date(
    props.sendData.diner_id.wait_time_date || props.sendData.diner_id.updatedAt
  );
  const currentTimeTwo = new Date().getTime();
  const updatedTimeNew = updatedTime.getTime();
  const waitTime = props.sendData.diner_id.wait_time * 60 * 1000;
  let updateWaitTime = updatedTimeNew + waitTime;
  let diff = updateWaitTime - currentTimeTwo;

  const seatedTime = new Date(props.sendData.updatedAt);
  var endSeatedTime = moment(seatedTime).format("YYYY-MM-DDTHH:mm");
  var startTimeNew = moment(createdAt).format("YYYY-MM-DDTHH:mm");
  let dateOneSeated = new Date(startTimeNew);
  let dateTwoSeated = new Date(endSeatedTime);

  let msDifferenceSeated = dateTwoSeated - dateOneSeated;
  let minutesSeated = Math.floor(msDifferenceSeated / 1000 / 60);

  function seated_time_difference(minutesSeated) {
    var hours = Math.floor(minutesSeated / 60);
    var nMinutesSeated = minutesSeated % 60;
    return hours + " HH : " + nMinutesSeated + " min";
  }

  return (
    <Modal
      open={true}
      onClose={props.localProps.onCloseModal}
      center
      classNames={{
        overlay: "customOverlay-request-accept-cancelled",
        modal: "customModal-request-accept-cancelled",
        closeButton: "customCloseButton",
        animationIn: "customEnterAnimation",
        animationOut: "customLeaveAnimation",
      }}
      animationDuration={1000}
    >
      <div className="top-request-accept-cancelled-header">
        <h4 className="text-capitalize">
          Request {props.sendData.diner_id.diner_status.toLowerCase()}
        </h4>
      </div>
      <div className="w-100 request-accept-cancelled">
        <div className="row menu-link-css">
          <div className="col">Name</div>
          <div className="col">Total</div>
          <div className="col">Timer</div>
        </div>
        <div className="request-accept-cancelled-border">
          <div className="row">
            <span className="col text-left small-text-reuse black-color">
              #{props.sendData.diner_id.diner_id}
            </span>
          </div>
          <div className="row request-accept-cancelled-top">
            <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
              <div className="d-flex ">
                <Image
                  fluid
                  src={require("../../../assets/images/ActionImages/walking-img.svg")}
                  alt="Order Type"
                  title="Order Type"
                />
                <p className="big-text-reuse green-color">
                  {props.sendData.diner_id.user_details.name}
                </p>
              </div>
            </div>
            <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 request-accept-cancelled-center">
              <div className="row">
                <div className="col p-0">
                  <p>
                    {props.sendData.diner_id.adult_count +
                      props.sendData.diner_id.kids_count}
                  </p>
                  <span className="">PAX</span>
                </div>
                <div className="col p-0">
                  <div className="d-flex align-items-center mb-2">
                    <Image
                      src={require("../../../assets/images/ActionImages/employees.png")}
                      fluid
                      alt="Adult"
                      title="Adult"
                      className="icon-image"
                    />
                    <span className="">
                      {props.sendData.diner_id.adult_count}
                    </span>
                  </div>
                  <div className="d-flex align-items-center ">
                    <Image
                      src={require("../../../assets/images/ActionImages/children.png")}
                      fluid
                      alt="Children"
                      title="Children"
                      className="icon-image"
                    />
                    <span className="">
                      {props.sendData.diner_id.kids_count}
                    </span>
                  </div>
                </div>
                <div className="col p-0">
                  <div className="d-flex align-items-center mb-2">
                    <Image
                      src={require("../../../assets/images/ActionImages/highchair.png")}
                      fluid
                      alt="Highchair"
                      title="Highchair"
                      className="icon-image-small"
                    />
                    <span className="">
                      {props.sendData.diner_id.high_chair}
                    </span>
                  </div>
                  <div className="d-flex align-items-center">
                    <Image
                      src={require("../../../assets/images/ActionImages/wheelchair.png")}
                      fluid
                      alt="Wheel Chair"
                      title="Wheel Chair"
                      className="icon-image-small"
                    />
                    <span className="">
                      {props.sendData.diner_id.handicap_chair}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 request-accept-cancelled-right">
              <p className="big-text-reuse gray-color pb-3">Wait time</p>
              <div className="d-flex justify-content-center">
                <div>
                  <p className="time-run">
                    <NewCountDown waitNew={diff} />
                  </p>
                  <span>HH:MM:SS</span>
                </div>
                <div className="img-div">
                  <Image
                    src={require("../../../assets/images/ActionImages/edit.png")}
                    fluid
                    alt="Wait time edit"
                    title="edit"
                  />
                </div>
              </div>
            </div>
          </div>

          {/*******************************
           * @DESC Middle Section One
           *******************************/}
          <div className="row middle-one-section">
            <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
              <p className="big-text-reuse gray-color pb-3">Total Wait time</p>
              <div className="time-section">
                <p className="big-text-reuse black-color">
                  {/* 00 <span className="small-text-reuse gray-color">HH</span> :
                  00 <span className="small-text-reuse gray-color">mins</span> */}
                  {props.sendData.diner_id.diner_status === "NOTSEATED"
                    ? time_convert(minutes)
                    : seated_time_difference(minutesSeated)}
                </p>
              </div>
            </div>
            <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 user-middle-section">
              <p className="big-text-reuse gray-color pb-3">User</p>
              <Image
                fluid
                src={require("../../../assets/images/ActionImages/maps-and-flags.svg")}
                alt="Location"
                title="Location"
              />
            </div>
            <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
              <p className="big-text-reuse gray-color pb-3">Date</p>
              <p className="big-text-reuse black-color">
                {moment(props.sendData.diner_id.createdAt).format(
                  "Do-MMM-YY HH:mm"
                )}
              </p>
            </div>
          </div>

          {/*******************************
           * @DESC Middle Section Two
           ******************************/}
          <div className="row align-items-center">
            <div className="col-4 col-sm-4 col-md-3 col-lg-3 col-xl-3">
              {props.sendData.diner_id.diner_status === "SEATED" ? (
                <div>
                  <DeletePopup
                    buttonDisplay="smallCancelButton"
                    displayPopup="seatingUnseated"
                    buttonText="Unseat"
                    bigText="Are you sure to Unseat ?"
                    dataSend={props.sendData.diner_id}
                  />
                </div>
              ) : "" || props.sendData.diner_id.diner_status === "NOTSEATED" ? (
                <div>
                  <DeletePopup
                    buttonDisplay="smallCancelButton"
                    displayPopup="resonFforCancellation"
                    actionCall={"seatingDashboardSide"}
                    buttonText="Cancel"
                    bigText="Are you sure to Cancel ?"
                    dataSend={props.sendData.diner_id._id}
                  />
                </div>
              ) : "" || props.sendData.diner_id.diner_status === "PENDING" ? (
                <DeletePopup
                  buttonDisplay="smallCancelButton"
                  displayPopup="resonFforCancellation"
                  actionCall={"pendingSide"}
                  buttonText="Reject"
                  bigText="Are you sure to Reject ?"
                  dataSend={props.sendData.diner_id._id}
                />
              ) : "" ||
                props.sendData.diner_id.diner_status === "COMPLETED" ||
                props.sendData.diner_id.diner_status === "REJECTED" ? (
                <DeletePopup
                  buttonDisplay="smallCancelButton"
                  displayPopup="historyReset"
                  buttonText="Reset"
                  bigText="Are you sure to Reset ?"
                  dataSend={props.sendData.diner_id}
                />
              ) : "" || props.sendData.diner_id.diner_status === "CANCELLED" ? (
                ""
              ) : (
                ""
              )}
            </div>
            <div className="col-4 col-sm-4 col-md-6 col-lg-6 col-xl-6 middle-two-section">
              <p className="big-text-reuse gray-color pb-2">
                Seating Preferences
              </p>
              <span className="big-text-reuse black-color">
                {props.sendData.diner_id.seating_preference}
              </span>
            </div>
            <div className="col-4 col-sm-4 col-md-3 col-lg-3 col-xl-3">
              {props.sendData.diner_id.diner_status === "SEATED" ? (
                <div>
                  <DeletePopup
                    buttonDisplay="smallSaveButton"
                    displayPopup="seatingCompleted"
                    buttonText="Complete"
                    bigText="Are you sure to Completed ?"
                    dataSend={props.sendData.diner_id}
                  />
                </div>
              ) : "" || props.sendData.diner_id.diner_status === "NOTSEATED" ? (
                <div>
                  <DeletePopup
                    buttonDisplay="smallSaveButton"
                    displayPopup="SeatedButton"
                    buttonText="Seat"
                    bigText="Are you sure to Seated ?"
                    dataSend={props.sendData.diner_id._id}
                  />
                </div>
              ) : "" || props.sendData.diner_id.diner_status === "PENDING" ? (
                <DeletePopup
                  buttonDisplay="smallSaveButton"
                  displayPopup="acceptButton"
                  buttonText="Accept"
                  bigText="Are you sure you want to accept ?"
                  dataSend={props.sendData.diner_id._id}
                />
              ) : "" ||
                props.sendData.diner_id.diner_status === "COMPLETED" ||
                props.sendData.diner_id.diner_status === "REJECTED" ||
                props.sendData.diner_id.diner_status === "CANCELLED" ? (
                ""
              ) : (
                ""
              )}
            </div>
          </div>

          {/*******************************
           * @DESC Middle Section Three
           *******************************/}
          <div className="middle-three-section">
            <PopupIconButtonReusable
              buttonClass="bigButton"
              image={require("../../../assets/images/ActionImages/phone-call.svg")}
              titleText="Calling Button"
            />
            <div className="button-space">
              <PopupIconButtonReusable
                buttonClass="bigButton"
                image={require("../../../assets/images/ActionImages/envelope.svg")}
                titleText="Send Sms Button"
              />
            </div>
            <PopupIconButtonReusable
              buttonClass="bigButton"
              image={require("../../../assets/images/ActionImages/view.svg")}
              titleText="View Button"
            />
          </div>
          {/*******************************
           * @DESC Bottom Section
           *******************************/}
          <div className="row text-left">
            <div className="col pr-0">
              <p className="big-text-reuse gray-color">Table / Room No.</p>
              <p className="small-text-reuse gray-color">
                Table No. :{" "}
                <span className="black-color">
                  {props.sendData.diner_id.table_number}
                </span>
              </p>
              <p className="small-text-reuse gray-color">
                Room No. :{" "}
                <span className="black-color">
                  {props.sendData.diner_id.room_number}
                </span>
              </p>
            </div>
            <div className="col">
              <p className="big-text-reuse gray-color">Special Occasion</p>
              <p className="small-text-reuse black-color">
                {props.sendData.diner_id.occasion}
              </p>
            </div>
            <div className="col">
              <p className="big-text-reuse gray-color">Status</p>
              <p className="big-text-reuse orange-color">
                {props.sendData.diner_id.diner_status}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ViewUserNotificationDetailsPopup;

//28-08-2020
